import * as React from "react";
import { useRef } from "react";
import { Actions, Container, FormWrapper } from "./SecurityForm.styled";
import { Button, InputField } from "../../../common";
import { useStores } from "../../../../stores";
import { observer } from "mobx-react";
import { useFormik } from "formik";
import { ChangePasswordSchema } from "../../../../validation-schems";
import { createDeferredValidationHandlers } from "../../../../helpers/formik";
import { useTranslation } from "react-i18next";

export const SecurityForm = observer(() => {
	const { authStore, notificationsStore } = useStores();
	const { userStore } = authStore;
	const formRef = useRef<HTMLFormElement>(null);

	const { t } = useTranslation();

	const formik = useFormik({
		validateOnBlur: true,
		validateOnChange: false,
		initialValues: {
			old_password: "",
			password: "",
			password_confirmation: "",
		},
		validationSchema: ChangePasswordSchema,
		onSubmit: async (values, { resetForm }) => {
			try {
				await userStore.update(values);

				// Уведомление о успешной смене пароля
				notificationsStore.add({
					title: "Password updated",
					message: "Your password has been successfully changed. You can now sign in with your new password.",
				});

				if (formRef.current) {
					formRef.current.reset();
				}
			} catch (e: any) {
				notificationsStore.error({
					message: e.errors.join("<br/>"),
				});
			}
		},
	});

	const oldPasswordField = createDeferredValidationHandlers(formik, "old_password");
	const passwordField = createDeferredValidationHandlers(formik, "password");
	const passwordConfirmationField = createDeferredValidationHandlers(formik, "password_confirmation");

	return (
		<Container>
			<FormWrapper ref={formRef} onSubmit={formik.handleSubmit}>
				<InputField
					small
					type="password"
					label="Current Password"
					placeholder="Enter your current password"
					name="old_password"
					value={formik.values.old_password}
					onChange={oldPasswordField.handleChange}
					onBlur={oldPasswordField.handleBlur}
					errorMessage={oldPasswordField.getError()}
				/>

				<InputField
					small
					type="password"
					label="New Password"
					placeholder="Enter your new password"
					name="password"
					value={formik.values.password}
					onChange={passwordField.handleChange}
					onBlur={passwordField.handleBlur}
					errorMessage={passwordField.getError()}
				/>

				<InputField
					small
					type="password"
					label="Repeat New Password"
					placeholder="Repeat your new password"
					name="password_confirmation"
					value={formik.values.password_confirmation}
					onChange={passwordConfirmationField.handleChange}
					onBlur={passwordConfirmationField.handleBlur}
					errorMessage={passwordConfirmationField.getError()}
				/>

				<Actions data-action>
					<Button type={"submit"}>{t("buttons.actions.change_password")}</Button>
				</Actions>
			</FormWrapper>
		</Container>
	);
});
